import './App.css';
import PedigreeViewerPage from './pages/pedigree-viewer-page';

function App() {
  return (
    <div className="App">
      <PedigreeViewerPage />
    </div>
  );
}

export default App;
